import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { startOfDay } from 'date-fns';
import { timeModel } from '.';
export class InvoiceDraftDatesModel {
    static fromDTO(dto) {
        return new InvoiceDraftDatesModel({
            dates: dto.dates.map(timeModel.fromDateStampObject),
            earliestBillableDate: startOfDay(timeModel.fromDateStampObject(dto.earliestBillableDate))
        });
    }
    static isInvoiceDraftDatesDTO(obj) {
        return obj && obj.dates && obj.earliestBillableDate;
    }
    dates() {
        return this.data.dates;
    }
    earliestBillableDate() {
        return this.data.earliestBillableDate;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
